export interface NewsArticle {
  id: string;
  title: string;
  source: string;
  sourceUrl: string; // Link to the news outlet's homepage
  articleUrl: string; // Link to the specific article
  publishedDate: string; // YYYY-MM-DD format
  excerpt: string; // Short excerpt (100-150 words max)
  imageUrl?: string; // Optional featured image URL
  category: 'Market Trends' | 'Regulations' | 'Technology' | 'Mergers & Acquisitions' | 'Industry Analysis';
  addedDate: string; // Date you added it to Fuel Central
}

export const industryNews: NewsArticle[] = [
  {
    id: '1',
    title: 'Modern Oral Drives Growth in Declining Nicotine Market',
    source: 'Convenience Store News',
    sourceUrl: 'https://www.csnews.com',
    articleUrl: 'https://csnews.com/modern-oral-drives-growth-declining-nicotine-market',
    publishedDate: '2025-12-20',
    excerpt: 'As traditional nicotine categories face declining sales, modern oral nicotine products are emerging as a growth driver for convenience stores. The category is attracting new consumers and offering retailers a higher-margin alternative to traditional tobacco products.',
    category: 'Market Trends',
    addedDate: '2025-12-22'
  },
  {
    id: '2',
    title: 'Arko Converts 194 Retail Stores to Dealer Sites',
    source: 'Convenience Store News',
    sourceUrl: 'https://www.csnews.com',
    articleUrl: 'https://csnews.com/arko-converts-194-retail-stores-dealer-sites',
    publishedDate: '2025-12-20',
    excerpt: 'Arko Corp. is converting 194 company-operated retail stores to dealer-operated sites as part of its strategic shift toward an asset-light business model. The move allows Arko to focus on fuel distribution while empowering local operators to manage retail operations.',
    category: 'Mergers & Acquisitions',
    addedDate: '2025-12-22'
  },
  {
    id: '3',
    title: 'Sunoco LP Completes $9.1B Parkland Acquisition',
    source: 'Convenience Store News',
    sourceUrl: 'https://www.csnews.com',
    articleUrl: 'https://csnews.com/sunoco-lp-completes-91b-parkland-acquisition',
    publishedDate: '2025-12-19',
    excerpt: 'Sunoco LP has finalized its $9.1 billion acquisition of Parkland Corporation, creating one of North America\'s largest fuel distributors. The merger strengthens Sunoco\'s wholesale fuel distribution network and expands its retail footprint across key markets.',
    category: 'Mergers & Acquisitions',
    addedDate: '2025-12-22'
  },
  {
    id: '4',
    title: 'Pump Price Drops Another 9 Cents',
    source: 'CSP Daily News',
    sourceUrl: 'https://www.cspdailynews.com',
    articleUrl: 'https://www.cspdailynews.com/fuels/pump-price-drops-another-9-cents',
    publishedDate: '2025-12-18',
    excerpt: 'National average gasoline prices fell another 9 cents this week, continuing a downward trend that began in November. The decline is attributed to lower crude oil prices and reduced seasonal demand. Industry analysts expect prices to remain stable through the winter months.',
    category: 'Market Trends',
    addedDate: '2025-12-22'
  },
  {
    id: '5',
    title: 'Rebel Owner Anabi Oil Acquires 12 Cox Family Stores Locations',
    source: 'CSP Daily News',
    sourceUrl: 'https://www.cspdailynews.com',
    articleUrl: 'https://www.cspdailynews.com/mergers-acquisitions/rebel-owner-anabi-oil-acquires-12-cox-family-stores-locations',
    publishedDate: '2025-12-17',
    excerpt: 'Anabi Oil, operator of the Rebel convenience store brand, has acquired 12 Cox Family Stores locations, expanding its presence in the regional market. The acquisition adds strategic locations to Anabi\'s growing portfolio and demonstrates continued consolidation in the c-store sector.',
    category: 'Mergers & Acquisitions',
    addedDate: '2025-12-22'
  }
];
